import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthComponent} from './auth.component';
import {RouterModule} from '@angular/router';
import {LoadingPageComponent} from '@dcp/configurator';
import {LogoutGuard} from '@spartacus/storefront';

import {LoginModule} from './login/login.module';
import {DcpLogoutGuard} from './logout/dcp-logout.guard';
import {BaselineComponent} from './baseline/baseline.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'auth',
        component: AuthComponent,
      },
      {
        path: 'baseline/:action',
        component: BaselineComponent,
      },
    ]),
    LoginModule,
    LoadingPageComponent,
    AuthComponent,
    BaselineComponent,
  ],
  exports: [RouterModule],
  providers: [{provide: LogoutGuard, useExisting: DcpLogoutGuard}],
})
export class AuthModule {}
